// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__25pTH","row":"Node_row__1pm_4","label":"Node_label__2CQ7L","footer":"Node_footer__1RDFB"};